export default __webpack_public_path__ + "static/media/call-stack.21911e0b.png";